import { styled } from '@mui/material';

export const Root = styled('div')({
  position: 'relative',
  width: '80%',
  height: 26,
  margin: 'auto',
});

export const Date = styled('div')({
  lineHeight: 'initial',
  fontWeight: 500,
  width: '100%',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  '@media(max-width: 1230px)': {
    fontSize: 15,
    fontWeight: '450',
  },
});

export const DelayedDays = styled('div')({
  lineHeight: 'initial',
  fontWeight: 600,
  fontSize: 14,
  height: 30,
  display: 'flex',
  justifyContent: 'center',
  '&.inAdvance': {
    color: '#418101',
  },
  '&.late': {
    color: '#D50022',
  },
  '@media(max-width: 1230px)': {
    fontSize: 13,
    fontWeight: 550,
  },
});

export const PendingText = styled('div')({
  lineHeight: 'initial',
  fontWeight: 600,
  fontSize: 15,
  height: 30,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  color: '#0096FF',
  '@media(max-width: 1230px)': {
    fontSize: 13,
    fontWeight: 550,
  },
});
